/** DispositionReportRoute — skin-aware switcher for /disposition-report. */
import { useUISkin } from "@/data/UISkinContext";
import DispositionReport from "./DispositionReport";
import DispositionReportCockpit from "./DispositionReportCockpit";
export default function DispositionReportRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <DispositionReportCockpit />;
  return <DispositionReport />;
}
